import React from 'react'

export default function P404 () {
  return (
    <h1>404 - Página não encontrada</h1>
  )
}
